export default "__VITE_ASSET__1e0f6bff__"